import { FunctionComponent, memo } from "react";
import { IProps } from "./agents.types";
import useTagGroups from "hooks-for/tag-groups/use-tag-groups";
import useTags from "hooks-for/tags/use-tags";
import { Page, PageContent, PageHeader } from "@edgetier/client-components";
import { SpinnerUntil } from "@edgetier/components";
import { IInteractionMetricsAvailable, InteractionType, ITag, ITagGroup } from "@edgetier/watchtower-types";

import ExploreFilters from "components-for/filters/explore-filters";
import AgentsTable from "./agents-table";

import "./agents.scss";

/**
 * A list of all the agents with data that can be used to compare them against each other.
 */
const Agents: FunctionComponent<IProps> = () => {
    const { data: tagGroups, isLoading: areTagGroupsLoading } = useTagGroups();
    const { data: tags, isLoading: areTagsLoading } = useTags();

    return (
        <Page>
            <PageHeader title="Agents" />
            <PageContent>
                <SpinnerUntil<{
                    tags: ITag[];
                    tagGroups: ITagGroup[];
                    interactionMetricsAvailable: IInteractionMetricsAvailable;
                }>
                    data={{ tagGroups, tags }}
                    isReady={!areTagGroupsLoading && !areTagsLoading}
                >
                    {(data) => (
                        <div className="agents">
                            <div>
                                <ExploreFilters
                                    hideFields={[]}
                                    customFieldItems={{
                                        interactionType: [InteractionType.Chat, InteractionType.Email],
                                    }}
                                    tags={data.tags}
                                    isResetEnabled={false}
                                    tagGroups={data.tagGroups}
                                    visibleFields={["agentId", "search"]}
                                    getWarnings={(formValues) => {
                                        return {
                                            ...(formValues.interactionType?.includes(InteractionType.Email) && {
                                                [InteractionType.Email]: "Email agent review is currently in beta",
                                            }),
                                        };
                                    }}
                                />
                            </div>
                            <AgentsTable />
                        </div>
                    )}
                </SpinnerUntil>
            </PageContent>
        </Page>
    );
};

export default memo(Agents);
